import React from 'react';

export const IcoArrowRigthCNovo = ({ width = '24', height = '24', style = {}, ...props }) => {
  return (
    <svg
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 12 18"
      width={width}
      height={height}
      style={{ ...style }}
      {...props}
    >
      <defs>
        <style>
          {`
            .st0 {
              fill: none;
              stroke: currentColor; /* Use "currentColor" para herdar a cor */
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-width: 2.5px;
            }

            .st1 {
              fill: #ff1a1a;
            }
          `}
        </style>
      </defs>
      <path className="st0" d="M2.2,16.5l7.6-7.6L2.2,1.3" />
      <circle className="st1" cx="8.1" cy="3.7" r="2" />
    </svg>
  );
};